import { redirect } from 'react-router-dom';
import { checkUserToken } from 'utils/author';
import { getReturnUrlFromRequestLoader } from 'utils/common/route';
import { isAuthed } from 'utils/common/session';

export const loginLoader = ({ request }) => {
  let returnUrl = getReturnUrlFromRequestLoader(request) || '/';

  const hasToken = isAuthed();
  const hasValidToken = checkUserToken();

  if (hasToken && hasValidToken) {
    const decodedReturnUrl = decodeURIComponent(returnUrl);

    if (['/login', '/waiting', '/eula'].includes(decodedReturnUrl)) {
      throw redirect('/');
    }

    throw redirect(decodedReturnUrl);
  }

  if (hasToken && !hasValidToken) {
    throw redirect(`/waiting?returnUrl=${encodeURIComponent(returnUrl)}`);
  }

  return { timestamp: new Date() };
};
